var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 106,
    viewBox: "0 0 76 106",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.5816 63.1947C19.9423 79.1839 28.7305 90.0856 41.789 103.144L39.7206 105.213C27.515 93.007 16.5406 82.5858 0.520959 69.2553L6.5816 63.1947Z",
    fill: "#1F1F1F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M75.5663 74.7206C61.1355 86.1706 51.2558 93.6535 39.7407 105.169L37.395 102.823C48.1579 92.06 57.2776 82.3129 68.6933 67.8476L75.5663 74.7206Z",
    fill: "#1F1F1F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M44.7011 2.58C41.2664 21.3619 41.9381 85.501 40.6451 102.565L37.5263 101.944C38.7349 85.995 36.1371 20.3412 35.5629 0.761328L44.7011 2.58Z",
    fill: "#1F1F1F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/Arrow.44413ce28cf140f7cc69c95c1f806ba0.svg";
export { ForwardRef as ReactComponent };